module.exports = __webpack_public_path__ + "img/logo_sync.1427a3b7.svg";